// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OrderSummary_title__HhF6O {
  margin: 0;
  font-family: Inter;
  font-weight: 700;
  font-style: Bold;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.04em;
  color: #404040;
  margin-bottom: 20px;
}
.OrderSummary_orderSummary__y1skb {
  width: 266px;
}

.OrderSummary_orderDetails__s9YJO {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.OrderSummary_detailRow__MQuAZ {
  display: flex;
  flex-direction: column;
}

.OrderSummary_detailTitle__-QL4U {
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: -0.04em;
  color: #999999;
  margin-bottom: 2px;
}

.OrderSummary_detailValue__hqzq6 {
  font-family: Inter;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.04em;
  color: #404040;
}

.OrderSummary_renewalInfo__cByMw {
  font-family: Inter;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: -0.04em;
  color: #999999;
  margin-top: 4px;
}

.OrderSummary_viewBreakdown__d9R6g {
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: -0.04em;
  color: #999999;
  cursor: pointer;
  margin-top: 20px;
}

.OrderSummary_viewBreakdown__d9R6g:hover {
  color: #858484;
}

.OrderSummary_arrowIcon__L1rl2 {
  width: 16px;
  height: 16px;
  color: #999999;
}

.OrderSummary_freeClubPass__4qvWI {
  background-color: #fdf2c4;
  padding: 2px 4px;
  border-radius: 4px;
  margin-left: 6px;
  font-family: Inter;
  font-weight: 600;
  font-style: Semi Bold;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0em;
  color: #786002;
}
  `, "",{"version":3,"sources":["webpack://./src/CheckoutPage/OrderSummary/index.module.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB","sourcesContent":[".title {\n  margin: 0;\n  font-family: Inter;\n  font-weight: 700;\n  font-style: Bold;\n  font-size: 20px;\n  line-height: 24px;\n  letter-spacing: -0.04em;\n  color: #404040;\n  margin-bottom: 20px;\n}\n.orderSummary {\n  width: 266px;\n}\n\n.orderDetails {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.detailRow {\n  display: flex;\n  flex-direction: column;\n}\n\n.detailTitle {\n  font-family: Inter;\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: -0.04em;\n  color: #999999;\n  margin-bottom: 2px;\n}\n\n.detailValue {\n  font-family: Inter;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: -0.04em;\n  color: #404040;\n}\n\n.renewalInfo {\n  font-family: Inter;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 16px;\n  letter-spacing: -0.04em;\n  color: #999999;\n  margin-top: 4px;\n}\n\n.viewBreakdown {\n  font-family: Inter;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 16px;\n  letter-spacing: -0.04em;\n  color: #999999;\n  cursor: pointer;\n  margin-top: 20px;\n}\n\n.viewBreakdown:hover {\n  color: #858484;\n}\n\n.arrowIcon {\n  width: 16px;\n  height: 16px;\n  color: #999999;\n}\n\n.freeClubPass {\n  background-color: #fdf2c4;\n  padding: 2px 4px;\n  border-radius: 4px;\n  margin-left: 6px;\n  font-family: Inter;\n  font-weight: 600;\n  font-style: Semi Bold;\n  font-size: 12px;\n  line-height: 12px;\n  letter-spacing: 0em;\n  color: #786002;\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `OrderSummary_title__HhF6O`,
	"orderSummary": `OrderSummary_orderSummary__y1skb`,
	"orderDetails": `OrderSummary_orderDetails__s9YJO`,
	"detailRow": `OrderSummary_detailRow__MQuAZ`,
	"detailTitle": `OrderSummary_detailTitle__-QL4U`,
	"detailValue": `OrderSummary_detailValue__hqzq6`,
	"renewalInfo": `OrderSummary_renewalInfo__cByMw`,
	"viewBreakdown": `OrderSummary_viewBreakdown__d9R6g`,
	"arrowIcon": `OrderSummary_arrowIcon__L1rl2`,
	"freeClubPass": `OrderSummary_freeClubPass__4qvWI`
};
export default ___CSS_LOADER_EXPORT___;
